import React from "react";
// import sections
import Hero from "../components/sections/Hero";
import '../App.css'

const Home = () => {
  return (
    <div className="fade-in">
      <Hero className="illustration-section-01" />
      {/* <Testimonial topDivider /> */}
      {/* <Cta split /> */}
    </div>
  );
};

export default Home;
